module.exports = __webpack_public_path__ + "img/svg/background-free-bet-hover.abfcf5fb8c2621e3c0c8bbf3efa9ea29.svg";